import isAllowed from '@/helpers/isAllowed';

export default {
  install: (app) => {
    app.config.globalProperties.$isAllowed = isAllowed;
  },
};
